<div class="form-group p-float-label" *ngIf="id">
	<textarea type="text"
		pInputTextarea
		class="form-control checking-field w-full"
		[required]="required"
		[ngClass]="{ 'ng-invalid': error }"
		[id]="id" [name]="id"
		[(ngModel)]="value"
		(ngModelChange)="valueEmit();"
		[autoResize]="autoResize"
		[disabled]="disabled"
		[rows]="rows"
	></textarea>
	<label for="{{ id }}">
		{{ label }}
		<span class="required" *ngIf="required">*</span>
	</label>
</div>
<span *ngIf="!id">ID not set</span>
